import { render, staticRenderFns } from "./ui-switch.vue?vue&type=template&id=5f0e65fe"
import script from "./ui-switch.vue?vue&type=script&lang=js"
export * from "./ui-switch.vue?vue&type=script&lang=js"
import style0 from "./ui-switch.vue?vue&type=style&index=0&id=5f0e65fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports